module.exports = __webpack_public_path__ + "img/btn-account-balance-th.3e42cccc.png";